module.exports = function(data) {
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }

 if (data.savedFilters) { ;
__p += '\n<aside>\n    <h5 data-action="show:all" class="' +
((__t = ( data.state.view === 'all' ? 'active' : 'inactive' )) == null ? '' : __t) +
'">' +
((__t = ( strings.allFilters )) == null ? '' : __t) +
' <i class="fal fa-chevron-right chevron-icon"></i></h5>\n    <h5 data-action="show:saved" class="' +
((__t = ( data.state.view === 'saved' ? 'active' : 'inactive' )) == null ? '' : __t) +
'">' +
((__t = ( strings.savedFilters )) == null ? '' : __t) +
' <i class="fal fa-chevron-right chevron-icon"></i></h5>\n    <h5 class="inactive no-action">' +
((__t = ( strings.recentFilters )) == null ? '' : __t) +
'</h5>\n    <div class="recent-filters">\n        ';
 data.filters.forEach(function(f) { ;
__p += '\n        <a href="#" data-action="apply:' +
__e( f.id ) +
'">' +
__e( f.name ) +
'</a>\n        ';
 }) ;
__p += '\n    </div>\n</aside>\n';
 } ;
__p += '\n<div class="view"></div>';
return __p
}